import React, { ReactElement } from 'react';
import CcxComponentProps from '../../../core/CcxComponent';
import Vpc from '../../../types/Vpc';
import AppFlagIcon from '../../ccx/common/AppFlagIcon';
import AppLogoBrandAws from '../../ccx/common/AppLogoBrandAws';
import AppLogoBrandCityCloud from '../../ccx/common/AppLogoBrandCityCloud';
import AppLogoBrandGoogleCloud from '../../ccx/common/AppLogoBrandGoogleCloud';
import AppLogoBrandSafespring from '../../ccx/common/AppLogoBrandSafespring';
import styles from './InstanceInformation.module.less';
import AppLogoBrandSyseleven from '../../ccx/common/AppLogoBrandSyseleven';

interface Props extends CcxComponentProps {
    vpc: Vpc;
    countryCode: string;
}

function InstanceInformation({
    vpc,
    countryCode,
    testId = 'InstanceInformation',
}: Props): ReactElement {
    const getCloudProviderLogo = (p: string) => {
        if (p === 'aws')
            return (
                <AppLogoBrandAws useExtended={true} height={20} width={20} />
            );
        if (p === 'safespring')
            return (
                <AppLogoBrandSafespring
                    useExtended={false}
                    height={16}
                    width={16}
                />
            );
        if (p === 'citycloud')
            return (
                <AppLogoBrandCityCloud
                    useExtended={false}
                    height={17}
                    width={18}
                />
            );
        if (p === 'gce')
            return (
                <AppLogoBrandGoogleCloud
                    useExtended={false}
                    height={16}
                    width={16}
                />
            );
        if (p === 'syseleven')
            return (
                <AppLogoBrandSyseleven
                    useExtended={false}
                    height={15}
                    width={24}
                />
            );
        return null;
    };

    return (
        <div className={styles.InstanceInformation} data-testid={testId}>
            <div data-testid={`${testId}Top`}>
                {getCloudProviderLogo(vpc.cloud)}
                <AppFlagIcon code={countryCode} />
                {vpc.region}
            </div>
            <div data-testid={`${testId}Bottom`}>
                <strong>{vpc.getName()}</strong>
            </div>
        </div>
    );
}

export default InstanceInformation;
